import { render, staticRenderFns } from "./RubyIcon.vue?vue&type=template&id=49b89e65&"
import script from "./RubyIcon.vue?vue&type=script&lang=js&"
export * from "./RubyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports